import store from '../../store';
const getSourcesCheck = targetEvent => {
  const missionAndEventMapping = store.getState().missionAndReward.missionAndEventMapping;
  const sources = missionAndEventMapping[targetEvent] || [];
  return sources && sources.length > 0;
};

export default getSourcesCheck;
